import { render, staticRenderFns } from "./CatalogItemsTable.vue?vue&type=template&id=1ea28b10&"
import script from "./CatalogItemsTable.vue?vue&type=script&lang=js&"
export * from "./CatalogItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemsTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
installComponents(component, {VChip,VDataTable,VFlex,VIcon,VPagination})
